import { Flex, Text } from '@buffer-mono/popcorn'

import styles from './ResolvingExplainerCard.module.css'

import type { JSX } from 'react'

export const ResolvingExplainerCard = (): JSX.Element => {
  return (
    <div className={styles.card}>
      <Flex direction="column" gap="xs">
        <Text size="sm" color="subtle" weight="medium">
          How it works
        </Text>
        <Text size="md" weight="bold">
          Resolving = marking as done
        </Text>
        <Text size="sm" color="subtle">
          To keep your list focused, resolve comments you don&apos;t want to
          reply to anymore. Don&apos;t worry, resolving has no effect on your
          social media.
        </Text>
      </Flex>
      <img
        src="https://buffer-publish.s3.us-east-1.amazonaws.com/images/resolve-example.svg"
        alt=""
        aria-hidden="true"
        className={styles.illustration}
      />
    </div>
  )
}
